<script setup>
import { useAssessment } from '@/composables/useAssessment'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Assessment',
  },
})

const { templates, results, loading, fetchTemplates, fetchResults } = useAssessment()

const subjectTypeOptions = [
  { title: 'Pegawai', value: 'employee', entity: 'employees' },
  { title: 'Vendor', value: 'vendor', entity: 'vendors' },
  { title: 'Unit', value: 'unit', entity: 'units' },
]

const templateId = ref(null)
const subjectType = ref('employee')
const subjectId = ref(null)

onMounted(fetchTemplates)

const templateOptions = computed(() => templates.value.map(t => ({ title: t.name, value: t.id })))
const subjectEntity = computed(() => subjectTypeOptions.find(o => o.value === subjectType.value)?.entity ?? 'employees')

const hasSelection = computed(() => !!templateId.value && !!subjectId.value)

watch([templateId, subjectId], () => {
  if (hasSelection.value) fetchResults(templateId.value, { subject_type: subjectType.value, subject_id: subjectId.value })
})
watch(subjectType, () => { subjectId.value = null })

const headers = [
  { title: 'Tanggal Nilai', key: 'assessed_at' },
  { title: 'Total Skor', key: 'total_score' },
  { title: 'Penilai', key: 'assessor' },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <h4 class="text-h4 font-weight-bold">
          Histori & Trend Penilaian
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Histori skor per subject dari waktu ke waktu (§10.4)
        </p>
      </VCol>
    </VRow>

    <VCard class="mb-4">
      <VCardText>
        <VRow>
          <VCol
            cols="12"
            md="4"
          >
            <VSelect
              v-model="templateId"
              :items="templateOptions"
              label="Template Penilaian"
              density="compact"
            />
          </VCol>
          <VCol
            cols="12"
            md="3"
          >
            <VSelect
              v-model="subjectType"
              :items="subjectTypeOptions"
              label="Tipe Subject"
              density="compact"
            />
          </VCol>
          <VCol
            cols="12"
            md="5"
          >
            <MasterDataPicker
              v-model="subjectId"
              :entity="subjectEntity"
              label="Subject"
            />
          </VCol>
        </VRow>
      </VCardText>
    </VCard>

    <template v-if="hasSelection">
      <VCard class="mb-4">
        <VCardTitle class="pa-6 pb-0">
          Grafik Trend
        </VCardTitle>
        <VCardText class="pa-6">
          <TrendChart
            :template-id="templateId"
            :subject-type="subjectType"
            :subject-id="subjectId"
          />
        </VCardText>
      </VCard>

      <VCard>
        <VDataTable
          :headers="headers"
          :items="results"
          :loading="loading"
          hide-default-footer
          :items-per-page="-1"
        >
          <template #item.assessed_at="{ item }">
            {{ item.assessed_at }}
          </template>
          <template #item.assessor="{ item }">
            {{ item.assessor?.name ?? '-' }}
          </template>
          <template #no-data>
            <div class="text-center py-10">
              <p class="text-medium-emphasis">
                Belum ada histori penilaian untuk subject ini.
              </p>
            </div>
          </template>
        </VDataTable>
      </VCard>
    </template>
  </div>
</template>
